import { rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const islandRules = composition => {
  const { variantIs, planIs, hasProduct } = composition.checkers;

  return [
    rule('island')
      .when(variantIs('island'))
      .set(() => ({
        constraints: {
          canMaximize: true,
        },
        container: {
          type: 'pill',
        },
        parts: {
          contents: {
            present: true,
          },
          headerText: {
            type: 'minimal',
            center: true,
          },
          aubySeal: {
            offsetType: 'xs',
            offsetBottom: true,
          },
          carousel: {
            size: 'lg',
            location: null,
          },
          dateBanner: {
            size: 'lg',
          },
          button: {
            size: 'lg',
            zIndex: composition.aspect.baseZIndex + 100 /* Place this over the accordion overlay */
          },
          accordion: {
            show: true,
            size: "sm",
          }
        }
      })),

    rule('island/premium')
      .when(variantIs('island').and(planIs('premium')).and(hasProduct))
      .set(() => ({
        parts: {
          headerImage: {
            show: true
          },
          headerText: {
            minimalOption: "only-authby",
            center: true
          },
          carousel: {
            location: null
          }
        }
      }))

  ];
};
